import { gql } from '@apollo/client';
import ORGANIZATION_ROLE_FRAGMENT from './organization-role';
import USER_FRAGMENT from './user';

const ORGANIZATION_USER_FRAGMENT = gql`
  fragment BaseOrganizationUser on UserOrganization {
    userId
    user {
      ...BaseUser
    }
    organizationRoles {
      ...BaseOrganizationRole
    }
  }
  ${USER_FRAGMENT}
  ${ORGANIZATION_ROLE_FRAGMENT}
`;

export default ORGANIZATION_USER_FRAGMENT;
